import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { ApiError } from '@shared/api/client';
import { copy } from '@shared/copy';
import { resolveErrorCopy } from '@shared/errors/catalog';
import { reportError } from '@shared/telemetry/errors';
import { Alert } from '@shared/ui/Alert';

/**
 * The router's last line. It renders the **mapped** operator copy and nothing
 * else — never a correlation id, a stack trace, an env value, an internal
 * hostname, or a status numeral. Those stay in the logs, and a hex string or a
 * numeral in the interface is technical vocabulary an operator cannot act on.
 *
 * Copy branches on `error_code`, never on `message`.
 */
export function RootErrorFallback() {
  const error = useRouteError();

  useEffect(() => {
    reportError(error);
  }, [error]);

  const status = error instanceof ApiError ? error.status : isRouteErrorResponse(error) ? error.status : 500;
  const code = error instanceof ApiError ? error.code : undefined;

  const { message, tone } = resolveErrorCopy(code, status);

  return (
    <div className="mx-auto flex max-w-measure flex-col gap-4 p-gutter">
      <h1>{copy.error.title}</h1>

      <Alert kind={tone === 'neutral' ? 'info' : tone} title={message}>
        <p>{copy.error.unaffected}</p>
      </Alert>

      <button
        type="button"
        onClick={() => window.location.reload()}
        className="hit-target self-start rounded-sm border border-border-strong px-5 py-3 text-sm hover:bg-hover-bg"
      >
        {copy.action.retry}
      </button>
    </div>
  );
}
